// Constants for different requests for current reducer
export default {
  shifts: 'SHIFTS',
  endShift: 'END_SHIFT',
};
